import { Box, TextField } from '@mui/material';
import { useRef, useEffect } from 'react';

interface BetweenEditorProps {
    ruleId: string;
    value: string;
    inputType?: string;
    onChange: (value: string) => void;
}

function BetweenEditor({ ruleId, value, inputType, onChange }: BetweenEditorProps) {
    const minRef = useRef<HTMLInputElement>(null);
    const maxRef = useRef<HTMLInputElement>(null);

    const values = value ? value.split('|') : ['', ''];
    const minValue = values[0] || '';
    const maxValue = values[1] || '';

    // Mettre à jour les valeurs si elles changent
    useEffect(() => {
        if (minRef.current && minRef.current.value !== minValue) {
            minRef.current.value = minValue;
        }
        if (maxRef.current && maxRef.current.value !== maxValue) {
            maxRef.current.value = maxValue;
        }
    }, [minValue, maxValue]);

    const handleBlur = () => {
        const min = minRef.current?.value || '';
        const max = maxRef.current?.value || '';
        onChange(`${min}|${max}`);
    };

    const type = inputType === 'date' ? 'date' : inputType === 'number' ? 'number' : 'text';

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
            <TextField
                inputRef={minRef}
                type={type}
                size="small"
                defaultValue={minValue}
                onBlur={handleBlur}
                placeholder="Min"
                sx={{ flex: 1 }}
                InputLabelProps={type === 'date' ? { shrink: true } : undefined}
            />
            <Box sx={{ px: 1, color: 'text.secondary' }}>et</Box>
            <TextField
                inputRef={maxRef}
                type={type}
                size="small"
                defaultValue={maxValue}
                onBlur={handleBlur}
                placeholder="Max"
                sx={{ flex: 1 }}
                InputLabelProps={type === 'date' ? { shrink: true } : undefined}
            />
        </Box>
    );
};

export default BetweenEditor;
